import moment from "moment";

/**
 * Berechnet das nächste Fälligkeitsdatum basierend auf dem letzten
 * Dabei wird der Tag des Monats beibehalten, sofern er im Zielmonat existiert
 */
export const calculateNextDueDate = (lastDue: moment.Moment): moment.Moment => {
    let newDue = lastDue.clone().add(1, "month");
    const originalDay = lastDue.date();

    // Setze ursprünglichen Tag im nächsten Monat
    newDue = newDue.date(originalDay);

    // Falls Tag im nächsten Monat nicht existiert (z.B. 31.), setze auf Monatsende
    if (
        newDue.month() !==
        lastDue
            .clone()
            .add(1, "month")
            .month()
    ) {
        newDue = lastDue
            .clone()
            .add(1, "month")
            .endOf("month");
    }

    return newDue;
};
